export default class UserPayroll {
    constructor() {
        this.id = undefined;       
        this.dateStart = undefined;
        this.dateEnd = undefined;
        this.limit = undefined;
        this.debitOverLimit = undefined;
        this.status = undefined;
        this.createdByEmail = undefined;
        this.payrolls = [];        
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;       
            to.dateStart = from.dateStart;
            to.dateEnd = from.dateEnd;
            to.limit = from.limit;
            to.debitOverLimit = from.debitOverLimit;
            to.status = from.status;
            to.createdByEmail = from.createdByEmail;
            to.payrolls = from.payrolls;  
        } else {
            to = new UserPayroll();
        }
    }

    static copy(to, from, locale) {
        UserPayroll.assign(from, to, locale);
        return to;
    }
}
